import { defineComponent as W, computed as L, ref as D, toRef as c, provide as Y, h as T, Fragment as Z, Teleport as ee, nextTick as te } from "vue";
import { uploadDraggerKey as ne } from "./ghl-ui.es403.js";
import { uploadInjectionKey as oe } from "./ghl-ui.es1173.js";
import { createSettledFileInfo as O, environmentSupportFile as re, isImageFile as ie, matchType as ae, createImageDataUrl as le } from "./ghl-ui.es1174.js";
import se from "./ghl-ui.es1175.js";
import de from "./ghl-ui.es1176.js";
import ue from "./ghl-ui.es1177.js";
import { throwError as ce, warn as fe } from "./ghl-ui.es877.js";
import me from "./ghl-ui.es878.js";
import N from "./ghl-ui.es879.js";
import he from "./ghl-ui.es901.js";
import ge from "./ghl-ui.es726.js";
import { useThemeClass as ve } from "./ghl-ui.es881.js";
import pe from "./ghl-ui.es1178.js";
import { createId as _ } from "./ghl-ui.es963.js";
import { call as M } from "./ghl-ui.es907.js";
var X = globalThis && globalThis.__awaiter || function(e, i, n, r) {
  function s(f) {
    return f instanceof n ? f : new n(function(u) {
      u(f);
    });
  }
  return new (n || (n = Promise))(function(f, u) {
    function R(o) {
      try {
        a(r.next(o));
      } catch (d) {
        u(d);
      }
    }
    function l(o) {
      try {
        a(r.throw(o));
      } catch (d) {
        u(d);
      }
    }
    function a(o) {
      o.done ? f(o.value) : s(o.value).then(R, l);
    }
    a((r = r.apply(e, i || [])).next());
  });
};
function Re(e, i, n) {
  const {
    doChange: r,
    xhrMap: s
  } = e;
  let f = 0;
  function u(l) {
    var a;
    let o = Object.assign({}, i, {
      status: "error",
      percentage: f
    });
    s.delete(i.id), o = O(((a = e.onError) === null || a === void 0 ? void 0 : a.call(e, {
      file: o,
      event: l
    })) || o), r(o, l);
  }
  function R(l) {
    var a;
    if (e.isErrorState) {
      if (e.isErrorState(n)) {
        u(l);
        return;
      }
    } else if (n.status < 200 || n.status >= 300) {
      u(l);
      return;
    }
    let o = Object.assign({}, i, {
      status: "finished",
      percentage: f
    });
    s.delete(i.id), o = O(((a = e.onFinish) === null || a === void 0 ? void 0 : a.call(e, {
      file: o,
      event: l
    })) || o), r(o, l);
  }
  return {
    handleXHRLoad: R,
    handleXHRError: u,
    handleXHRAbort(l) {
      const a = Object.assign({}, i, {
        status: "removed",
        file: null,
        percentage: f
      });
      s.delete(i.id), r(a, l);
    },
    handleXHRProgress(l) {
      const a = Object.assign({}, i, {
        status: "uploading"
      });
      if (l.lengthComputable) {
        const o = Math.ceil(l.loaded / l.total * 100);
        a.percentage = o, f = o;
      }
      r(a, l);
    }
  };
}
function be(e) {
  const {
    inst: i,
    file: n,
    data: r,
    headers: s,
    withCredentials: f,
    action: u,
    customRequest: R
  } = e, {
    doChange: l
  } = e.inst;
  let a = 0;
  R({
    file: n,
    data: r,
    headers: s,
    withCredentials: f,
    action: u,
    onProgress(o) {
      const d = Object.assign({}, n, {
        status: "uploading"
      }), U = o.percent;
      d.percentage = U, a = U, l(d);
    },
    onFinish() {
      var o;
      let d = Object.assign({}, n, {
        status: "finished",
        percentage: a
      });
      d = O(((o = i.onFinish) === null || o === void 0 ? void 0 : o.call(i, {
        file: d
      })) || d), l(d);
    },
    onError() {
      var o;
      let d = Object.assign({}, n, {
        status: "error",
        percentage: a
      });
      d = O(((o = i.onError) === null || o === void 0 ? void 0 : o.call(i, {
        file: d
      })) || d), l(d);
    }
  });
}
function ye(e, i, n) {
  const r = Re(e, i, n);
  n.onabort = r.handleXHRAbort, n.onerror = r.handleXHRError, n.onload = r.handleXHRLoad, n.upload && (n.upload.onprogress = r.handleXHRProgress);
}
function A(e, i) {
  return typeof e == "function" ? e({
    file: i
  }) : e || {};
}
function Ce(e, i, n) {
  const r = A(i, n);
  r && Object.keys(r).forEach((s) => {
    e.setRequestHeader(s, r[s]);
  });
}
function we(e, i, n) {
  const r = A(i, n);
  r && Object.keys(r).forEach((s) => {
    e.append(s, r[s]);
  });
}
function Fe(e, i, n, {
  method: r,
  action: s,
  withCredentials: f,
  responseType: u,
  headers: R,
  data: l
}) {
  const a = new XMLHttpRequest();
  a.responseType = u, e.xhrMap.set(n.id, a), a.withCredentials = f;
  const o = new FormData();
  if (we(o, l, n), n.file !== null && o.append(i, n.file), ye(e, n, a), s !== void 0) {
    a.open(r.toUpperCase(), s), Ce(a, R, n), a.send(o);
    const d = Object.assign({}, n, {
      status: "uploading"
    });
    e.doChange(d);
  }
}
const Be = Object.assign(Object.assign({}, N.props), {
  name: {
    type: String,
    default: "file"
  },
  accept: String,
  action: String,
  customRequest: Function,
  directory: Boolean,
  directoryDnd: {
    type: Boolean,
    default: void 0
  },
  method: {
    type: String,
    default: "POST"
  },
  multiple: Boolean,
  showFileList: {
    type: Boolean,
    default: !0
  },
  data: [Object, Function],
  headers: [Object, Function],
  withCredentials: Boolean,
  responseType: {
    type: String,
    default: ""
  },
  disabled: {
    type: Boolean,
    default: void 0
  },
  onChange: Function,
  onRemove: Function,
  onFinish: Function,
  onError: Function,
  onBeforeUpload: Function,
  isErrorState: Function,
  /** currently not used */
  onDownload: Function,
  defaultUpload: {
    type: Boolean,
    default: !0
  },
  fileList: Array,
  "onUpdate:fileList": [Function, Array],
  onUpdateFileList: [Function, Array],
  fileListClass: String,
  fileListStyle: [String, Object],
  defaultFileList: {
    type: Array,
    default: () => []
  },
  showCancelButton: {
    type: Boolean,
    default: !0
  },
  showRemoveButton: {
    type: Boolean,
    default: !0
  },
  showDownloadButton: Boolean,
  showRetryButton: {
    type: Boolean,
    default: !0
  },
  showPreviewButton: {
    type: Boolean,
    default: !0
  },
  listType: {
    type: String,
    default: "text"
  },
  onPreview: Function,
  shouldUseThumbnailUrl: {
    type: Function,
    default: (e) => re ? ie(e) : !1
  },
  createThumbnailUrl: Function,
  abstract: Boolean,
  max: Number,
  showTrigger: {
    type: Boolean,
    default: !0
  },
  imageGroupProps: Object,
  inputProps: Object,
  triggerClass: String,
  triggerStyle: [String, Object],
  renderIcon: Function
}), Ae = W({
  name: "Upload",
  props: Be,
  setup(e) {
    e.abstract && e.listType === "image-card" && ce("upload", "when the list-type is image-card, abstract is not supported.");
    const {
      mergedClsPrefixRef: i,
      inlineThemeDisabled: n
    } = me(e), r = N("Upload", "-upload", ue, pe, e, i), s = he(e), f = L(() => {
      const {
        max: t
      } = e;
      return t !== void 0 ? B.value.length >= t : !1;
    }), u = D(e.defaultFileList), R = c(e, "fileList"), l = D(null), a = {
      value: !1
    }, o = D(!1), d = /* @__PURE__ */ new Map(), U = ge(R, u), B = L(() => U.value.map(O));
    function I() {
      var t;
      (t = l.value) === null || t === void 0 || t.click();
    }
    function V(t) {
      const m = t.target;
      H(m.files ? Array.from(m.files).map((v) => ({
        file: v,
        entry: null,
        source: "input"
      })) : null, t), m.value = "";
    }
    function $(t) {
      const {
        "onUpdate:fileList": m,
        onUpdateFileList: v
      } = e;
      m && M(m, t), v && M(v, t), u.value = t;
    }
    const E = L(() => e.multiple || e.directory);
    function H(t, m) {
      if (!t || t.length === 0)
        return;
      const {
        onBeforeUpload: v
      } = e;
      t = E.value ? t : [t[0]];
      const {
        max: C,
        accept: y
      } = e;
      t = t.filter(({
        file: h,
        source: g
      }) => g === "dnd" && (y != null && y.trim()) ? ae(h.name, h.type, y) : !0), C && (t = t.slice(0, C - B.value.length));
      const p = _();
      Promise.all(t.map(({
        file: h,
        entry: g
      }) => X(this, void 0, void 0, function* () {
        var w;
        const F = {
          id: _(),
          batchId: p,
          name: h.name,
          status: "pending",
          percentage: 0,
          file: h,
          url: null,
          type: h.type,
          thumbnailUrl: null,
          fullPath: (w = g == null ? void 0 : g.fullPath) !== null && w !== void 0 ? w : `/${h.webkitRelativePath || h.name}`
        };
        return !v || (yield v({
          file: F,
          fileList: B.value
        })) !== !1 ? F : null;
      }))).then((h) => X(this, void 0, void 0, function* () {
        let g = Promise.resolve();
        h.forEach((w) => {
          g = g.then(te).then(() => {
            w && S(w, m, {
              append: !0
            });
          });
        }), yield g;
      })).then(() => {
        e.defaultUpload && x();
      });
    }
    function x(t) {
      const {
        method: m,
        action: v,
        withCredentials: C,
        headers: y,
        data: p,
        name: h
      } = e, g = t !== void 0 ? B.value.filter((F) => F.id === t) : B.value, w = t !== void 0;
      g.forEach((F) => {
        const {
          status: j
        } = F;
        (j === "pending" || j === "error" && w) && (e.customRequest ? be({
          inst: {
            doChange: S,
            xhrMap: d,
            onFinish: e.onFinish,
            onError: e.onError
          },
          file: F,
          action: v,
          withCredentials: C,
          headers: y,
          data: p,
          customRequest: e.customRequest
        }) : Fe({
          doChange: S,
          xhrMap: d,
          onFinish: e.onFinish,
          onError: e.onError,
          isErrorState: e.isErrorState
        }, h, F, {
          method: m,
          action: v,
          withCredentials: C,
          responseType: e.responseType,
          headers: y,
          data: p
        }));
      });
    }
    const S = (t, m, v = {
      append: !1,
      remove: !1
    }) => {
      const {
        append: C,
        remove: y
      } = v, p = Array.from(B.value), h = p.findIndex((g) => g.id === t.id);
      if (C || y || ~h) {
        C ? p.push(t) : y ? p.splice(h, 1) : p.splice(h, 1, t);
        const {
          onChange: g
        } = e;
        g && g({
          file: t,
          fileList: p,
          event: m
        }), $(p);
      } else
        process.env.NODE_ENV !== "production" && fe("upload", "File has no corresponding id in current file list.");
    };
    function k(t) {
      var m;
      if (t.thumbnailUrl)
        return t.thumbnailUrl;
      const {
        createThumbnailUrl: v
      } = e;
      return v ? (m = v(t.file, t)) !== null && m !== void 0 ? m : t.url || "" : t.url ? t.url : t.file ? le(t.file) : "";
    }
    const P = L(() => {
      const {
        common: {
          cubicBezierEaseInOut: t
        },
        self: {
          draggerColor: m,
          draggerBorder: v,
          draggerBorderHover: C,
          itemColorHover: y,
          itemColorHoverError: p,
          itemTextColorError: h,
          itemTextColorSuccess: g,
          itemTextColor: w,
          itemIconColor: F,
          itemDisabledOpacity: j,
          lineHeight: q,
          borderRadius: G,
          fontSize: K,
          itemBorderImageCardError: J,
          itemBorderImageCard: Q
        }
      } = r.value;
      return {
        "--n-bezier": t,
        "--n-border-radius": G,
        "--n-dragger-border": v,
        "--n-dragger-border-hover": C,
        "--n-dragger-color": m,
        "--n-font-size": K,
        "--n-item-color-hover": y,
        "--n-item-color-hover-error": p,
        "--n-item-disabled-opacity": j,
        "--n-item-icon-color": F,
        "--n-item-text-color": w,
        "--n-item-text-color-error": h,
        "--n-item-text-color-success": g,
        "--n-line-height": q,
        "--n-item-border-image-card-error": J,
        "--n-item-border-image-card": Q
      };
    }), b = n ? ve("upload", void 0, P, e) : void 0;
    Y(oe, {
      mergedClsPrefixRef: i,
      mergedThemeRef: r,
      showCancelButtonRef: c(e, "showCancelButton"),
      showDownloadButtonRef: c(e, "showDownloadButton"),
      showRemoveButtonRef: c(e, "showRemoveButton"),
      showRetryButtonRef: c(e, "showRetryButton"),
      onRemoveRef: c(e, "onRemove"),
      onDownloadRef: c(e, "onDownload"),
      mergedFileListRef: B,
      triggerClassRef: c(e, "triggerClass"),
      triggerStyleRef: c(e, "triggerStyle"),
      shouldUseThumbnailUrlRef: c(e, "shouldUseThumbnailUrl"),
      renderIconRef: c(e, "renderIcon"),
      xhrMap: d,
      submit: x,
      doChange: S,
      showPreviewButtonRef: c(e, "showPreviewButton"),
      onPreviewRef: c(e, "onPreview"),
      getFileThumbnailUrlResolver: k,
      listTypeRef: c(e, "listType"),
      dragOverRef: o,
      openOpenFileDialog: I,
      draggerInsideRef: a,
      handleFileAddition: H,
      mergedDisabledRef: s.mergedDisabledRef,
      maxReachedRef: f,
      fileListClassRef: c(e, "fileListClass"),
      fileListStyleRef: c(e, "fileListStyle"),
      abstractRef: c(e, "abstract"),
      acceptRef: c(e, "accept"),
      cssVarsRef: n ? void 0 : P,
      themeClassRef: b == null ? void 0 : b.themeClass,
      onRender: b == null ? void 0 : b.onRender,
      showTriggerRef: c(e, "showTrigger"),
      imageGroupPropsRef: c(e, "imageGroupProps"),
      mergedDirectoryDndRef: L(() => {
        var t;
        return (t = e.directoryDnd) !== null && t !== void 0 ? t : e.directory;
      })
    });
    const z = {
      clear: () => {
        u.value = [];
      },
      submit: x,
      openOpenFileDialog: I
    };
    return Object.assign({
      mergedClsPrefix: i,
      draggerInsideRef: a,
      inputElRef: l,
      mergedTheme: r,
      dragOver: o,
      mergedMultiple: E,
      cssVars: n ? void 0 : P,
      themeClass: b == null ? void 0 : b.themeClass,
      onRender: b == null ? void 0 : b.onRender,
      handleFileInputChange: V
    }, z);
  },
  render() {
    var e, i;
    const {
      draggerInsideRef: n,
      mergedClsPrefix: r,
      $slots: s,
      directory: f,
      onRender: u
    } = this;
    if (s.default && !this.abstract) {
      const l = s.default()[0];
      !((e = l == null ? void 0 : l.type) === null || e === void 0) && e[ne] && (n.value = !0);
    }
    const R = T("input", Object.assign({}, this.inputProps, {
      ref: "inputElRef",
      type: "file",
      class: `${r}-upload-file-input`,
      accept: this.accept,
      multiple: this.mergedMultiple,
      onChange: this.handleFileInputChange,
      // @ts-expect-error // seems vue-tsc will add the prop, so we can't use expect-error
      webkitdirectory: f || void 0,
      directory: f || void 0
    }));
    return this.abstract ? T(Z, null, (i = s.default) === null || i === void 0 ? void 0 : i.call(s), T(ee, {
      to: "body"
    }, R)) : (u == null || u(), T("div", {
      class: [`${r}-upload`, n.value && `${r}-upload--dragger-inside`, this.dragOver && `${r}-upload--drag-over`, this.themeClass],
      style: this.cssVars
    }, R, this.showTrigger && this.listType !== "image-card" && T(se, null, s), this.showFileList && T(de, null, s)));
  }
});
export {
  Ae as default,
  Be as uploadProps
};
